const rowSizingCls = "_275r18lkfxu";
const thead = "_275tfojcnp";

export { rowSizingCls, thead };
import "./table.root.style.linaria.module.css";
//# sourceMappingURL=table.root.style.js.map
